import React from "react";
import { history } from "../../util";

class InjectedTenantHTML extends React.Component {
  componentDidMount() {
    this.linkListener = e => {
      let matchedTarget;

      if (typeof e.target.closest === "function") {
        // This is for nested-style links e.g. <a><b>Blah</b></a>
        matchedTarget = e.target.closest("a");
      } else {
        matchedTarget = e.target.tagName.toLowerCase() === "a" && e.target;
      }

      if (matchedTarget) {
        if (this.props.forceNewTab) {
          matchedTarget.setAttribute("target", "_blank");
          return;
        }

        let { host, pathname, search, hash } = matchedTarget;
        if (host === window.location.host && !window.EVENTIVE_IS_EVERYWHERE) {
          history.push(pathname + search + hash);
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };

    this._container.addEventListener("click", this.linkListener);
  }

  componentWillUnmount() {
    this._container.removeEventListener("click", this.linkListener);
  }

  render() {
    let { style, content, element } = this.props,
      Element = element || "div";

    return (
      <Element
        ref={ref => (this._container = ref)}
        style={style}
        className="tenant-injected-html"
        dangerouslySetInnerHTML={content}
      />
    );
  }
}

export default InjectedTenantHTML;



// WEBPACK FOOTER //
// ./src/app/components/partials/injected-tenant-html.jsx